@import (reference) '../../../../constants/spacing.module.less';

.text-section {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: @space-16 @space-16 @space-24 @space-16;
  color: var(--default--text-color--17);
  height: 320px;
}
